import { Vector3 } from "@babylonjs/core/Maths/math.vector";
export class ImmediateRigidBodyImpl {
    shouldSync;
    constructor() {
        this.shouldSync = true;
    }
    setTransformMatrixFromArray(motionStatePtr, kinematicStatePtr, array, offset) {
        const m = motionStatePtr.array;
        m[4 /* MotionStateOffsetsInFloat32Array.MatrixRowX */ + 0] = array[offset];
        m[8 /* MotionStateOffsetsInFloat32Array.MatrixRowY */ + 0] = array[offset + 1];
        m[12 /* MotionStateOffsetsInFloat32Array.MatrixRowZ */ + 0] = array[offset + 2];
        m[4 /* MotionStateOffsetsInFloat32Array.MatrixRowX */ + 1] = array[offset + 4];
        m[8 /* MotionStateOffsetsInFloat32Array.MatrixRowY */ + 1] = array[offset + 5];
        m[12 /* MotionStateOffsetsInFloat32Array.MatrixRowZ */ + 1] = array[offset + 6];
        m[4 /* MotionStateOffsetsInFloat32Array.MatrixRowX */ + 2] = array[offset + 8];
        m[8 /* MotionStateOffsetsInFloat32Array.MatrixRowY */ + 2] = array[offset + 9];
        m[12 /* MotionStateOffsetsInFloat32Array.MatrixRowZ */ + 2] = array[offset + 10];
        m[16 /* MotionStateOffsetsInFloat32Array.Translation */ + 0] = array[offset + 12];
        m[16 /* MotionStateOffsetsInFloat32Array.Translation */ + 1] = array[offset + 13];
        m[16 /* MotionStateOffsetsInFloat32Array.Translation */ + 2] = array[offset + 14];
        const kinematicState = kinematicStatePtr.array;
        if ((kinematicState[0] & 240 /* TemporalKinematicState.ReadMask */) !== 0 /* TemporalKinematicState.Disabled */) {
            kinematicState[0] = (kinematicState[0] & 15 /* TemporalKinematicState.WriteMask */) | 32 /* TemporalKinematicState.WaitForChange */;
        }
    }
    setDynamicTransformMatrixFromArray(worldTransformPtr, array, offset) {
        const m = worldTransformPtr.array;
        m[0 /* BtTransformOffsets.MatrixRowX */ + 0] = array[offset];
        m[16 /* BtTransformOffsets.MatrixRowY */ + 0] = array[offset + 1];
        m[32 /* BtTransformOffsets.MatrixRowZ */ + 0] = array[offset + 2];
        m[0 /* BtTransformOffsets.MatrixRowX */ + 1] = array[offset + 4];
        m[16 /* BtTransformOffsets.MatrixRowY */ + 1] = array[offset + 5];
        m[32 /* BtTransformOffsets.MatrixRowZ */ + 1] = array[offset + 6];
        m[0 /* BtTransformOffsets.MatrixRowX */ + 2] = array[offset + 8];
        m[16 /* BtTransformOffsets.MatrixRowY */ + 2] = array[offset + 9];
        m[32 /* BtTransformOffsets.MatrixRowZ */ + 2] = array[offset + 10];
        m[48 /* BtTransformOffsets.Translation */ + 0] = array[offset + 12];
        m[48 /* BtTransformOffsets.Translation */ + 1] = array[offset + 13];
        m[48 /* BtTransformOffsets.Translation */ + 2] = array[offset + 14];
    }
    getEffectiveKinematicState(kinematicStatePtr) {
        return (kinematicStatePtr.array[0] & 15 /* KinematicToggleState.ReadMask */) !== 0 /* KinematicToggleState.Disabled */;
    }
    setEffectiveKinematicState(kinematicStatePtr, value) {
        const kinematicState = kinematicStatePtr.array;
        if (value) {
            kinematicState[0] = (kinematicState[0] & 240 /* KinematicToggleState.WriteMask */) | 1 /* KinematicToggleState.Enabled */;
        }
        else {
            kinematicState[0] = (kinematicState[0] & 240 /* KinematicToggleState.WriteMask */) | 0 /* KinematicToggleState.Disabled */;
        }
    }
    setDamping(wasmInstance, bodyPtr, linearDamping, angularDamping) {
        wasmInstance.rigidBodySetDamping(bodyPtr, linearDamping, angularDamping);
    }
    getLinearDamping(wasmInstance, bodyPtr) {
        return wasmInstance.rigidBodyGetLinearDamping(bodyPtr);
    }
    getAngularDamping(wasmInstance, bodyPtr) {
        return wasmInstance.rigidBodyGetAngularDamping(bodyPtr);
    }
    setMassProps(wasmInstance, bodyPtr, mass, localInertia) {
        wasmInstance.rigidBodySetMassProps(bodyPtr, mass, localInertia.x, localInertia.y, localInertia.z);
    }
    getMass(wasmInstance, bodyPtr) {
        return wasmInstance.rigidBodyGetMass(bodyPtr);
    }
    getLocalInertia(wasmInstance, bodyPtr) {
        const outBufferPtr = wasmInstance.allocateBuffer(3 * 4 /* Constants.A32BytesPerElement */);
        const outBuffer = wasmInstance.createTypedArray(Float32Array, outBufferPtr, 3).array;
        wasmInstance.rigidBodyGetLocalInertia(bodyPtr, outBufferPtr);
        const result = new Vector3(outBuffer[0], outBuffer[1], outBuffer[2]);
        wasmInstance.deallocateBuffer(outBufferPtr, 3 * 4 /* Constants.A32BytesPerElement */);
        return result;
    }
    translate(wasmInstance, bodyPtr, translation) {
        wasmInstance.rigidBodyTranslate(bodyPtr, translation.x, translation.y, translation.z);
    }
}
